import * as React from 'react';

import { ArticleCardSkeleton } from '@xing-com/crate-career-hub-article-card';
import { GridContainer, GridItem } from '@xing-com/grid';

import { MOCKED_ARTICLE_NUMBER, MOCKED_TOPIC_NUMBER } from '../constants';

import { ArticleBlockWrapper } from './article-block-wrapper';
import { Styled } from './topic-skeleton.styles';

export const TopicSkeleton: React.FC = () => (
  <>
    {Array.from(Array(MOCKED_TOPIC_NUMBER).keys()).map((id, index) => (
      <React.Fragment key={`${id}-${index}`}>
        <GridContainer variant="FullSize">
          <Styled.GridItem span={4}>
            <Styled.SkeletonHeadline amountRows={1} />
          </Styled.GridItem>
          <GridItem span={3} spanLarge={2} start={10} startLarge={11}>
            <Styled.SkeletonButton size="medium" />
          </GridItem>
          <GridItem span={12}>
            <Styled.SkeletonBody />
          </GridItem>
        </GridContainer>
        <ArticleBlockWrapper>
          {Array.from(Array(MOCKED_ARTICLE_NUMBER).keys()).map((id) => (
            <GridItem
              key={`mocked_article_${id}-${index}`}
              span={6}
              spanLarge={4}
            >
              <ArticleCardSkeleton />
            </GridItem>
          ))}
        </ArticleBlockWrapper>
      </React.Fragment>
    ))}
  </>
);
